// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_uueaJ","icon":"index_icon_Hg2lm"};